/**
 * 加载支付sdk，一期只支持 端外支付面板
 */

import loader from '../core/loader'
import { getSdkUrlCfg } from '../core/getSDKUrlConf'
// eslint-disable-next-line no-undef
let payDom // 端外支付面板的挂载节点

function getSDKUrl (opt) {
  return getSdkUrlCfg(opt.offline, 'internal', 'paySDK', opt.version || '0.6.9')
}

function createPayDom () {
  var payDom = document.createElement('div')
  payDom.setAttribute('class', '__pay__')
  document.body.appendChild(payDom)
  return payDom
}

export function sdk (opts, cb) {
  loader.sdkReady('DPay', getSDKUrl(opts), (sdk) => {
    if (sdk && sdk.init) {
      // 旧版支付 0.0.2
      sdk.init(opts)
    } else if (sdk && sdk.pay) {
      // 新版支付 0.4.3
      if (!payDom) {
        if (opts.el) {
          payDom = opts.el
        } else {
          payDom = createPayDom()
        }
      }
      sdk.pay(
        {
          direct: opts.direct || false,
          pay: opts.pay || {},
          el: payDom,
          theme: 'orange',
          router: opts.router || true,
          lang: opts.lang || 'zh-CN'
        },
        function (err, result) {
          if (err) {
            return opts.fail && opts.fail(err, result)
          }
          opts.success && opts.success(result)
        }
      )
      sdk.once('beforeEnter', function (page, fromPage) {
        opts.beforeEnter && opts.beforeEnter(page, fromPage)
      })
      sdk.once('close', function (panel) {
        opts.cancel && opts.cancel(panel)
      })
    } else {
      cb({
        errno: -1,
        errmsg: '支付sdk加载异常'
      })
    }
  })
}
